export class Settings {
  public videoVolume = 100;
  public videoMuteEnabled = false;
  public audioMuteEnabled = false;
  public microVolume = 100;
  public videoDevice: MediaDeviceInfo = null;
  public audioDevice: MediaDeviceInfo = null;
}
